import React, { useCallback, useRef } from "react";
import styled from 'styled-components';
import CoauthorButton from "./coauthorButton.component";

const CoauthorPortal = styled('div')({
  position: 'absolute' // this removes the div from the DOM flow, e.g. flex layout
});

export default function CoauthorButtonWithPortal ({ onClick, ...props }) {
  const coauthorPortal = useRef(null);
  const handleClick = useCallback((e) => {
    onClick(e, coauthorPortal.current);
  }, [onClick])

  return (
    <>
      <CoauthorButton onClick={handleClick} {...props} />
      <CoauthorPortal ref={coauthorPortal} />
    </>
  );
}
